'use client'

import { type Messages, setupI18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import {
	createContext,
	type PropsWithChildren,
	useContext,
	useMemo,
	useState,
} from 'react'

import type { Locale } from '~/i18n/routing'

type LocaleContextValue = {
	locale: Locale
}

const LocaleContext = createContext<LocaleContextValue>({
	locale: 'fr',
})

export const useLocaleContext = () => useContext(LocaleContext)

export const LocaleProvider = ({
	children,
	locale,
	messages,
}: PropsWithChildren<{
	locale: Locale
	messages: Messages
}>) => {
	const value = useMemo(() => ({ locale }), [locale])
	const [i18n] = useState(() =>
		setupI18n({ locale, messages: { [locale]: messages } }),
	)

	return (
		<LocaleContext.Provider value={value}>
			<I18nProvider i18n={i18n}>{children}</I18nProvider>
		</LocaleContext.Provider>
	)
}
